// 优化中心建议卡片展示（与 lib/revision-utils.mjs 字段/级别规则保持一致）
//
// ⚠️ MIRROR — 这四个 helper 是 lib/revision-utils.mjs 的前端镜像
//   后端: lib/revision-utils.mjs (formatRevisionFieldLabel / normalizeRevisionSeverityClass /
//                                  formatRevisionSeverityLabel / hasMasterRevisionInstructions)
//   前端: 本文件
// 后端改了字段/级别枚举，本文件必须同步更新；否则前端会把后端的新 source 显示成「通用」。

export function formatRevisionFieldLabel(field) {
  const f = String(field || '').trim();
  const lower = f.toLowerCase();
  if (lower === 'title' || f.includes('标题')) return '标题';
  const bulletMatch = lower.match(/^bullets?\[(\d+)\]$/);
  if (bulletMatch) return `五点 · 第${Number(bulletMatch[1]) + 1}条`;
  if (lower.startsWith('bullets') || lower.includes('bullet') || f.includes('五点') || f.includes('要点')) {
    return '五点描述';
  }
  if (lower === 'description' || f.includes('描述')) return '商品描述';
  if (
    lower === 'searchterms'
    || lower.includes('search')
    || f.includes('搜索')
    || (f.includes('关键词') && !f.includes('五点'))
  ) {
    return '后台搜索词';
  }
  if (lower.includes('aplus') || f.includes('A+') || f.includes('a+')) return 'A+ 图文';
  // 与后端保持一致：qa 标签
  if (lower === 'qa' || lower.startsWith('qa') || f.includes('QA') || f.includes('问答')) return 'QA 问答对';
  return f || '通用';
}

export function normalizeRevisionSeverityClass(severity) {
  const s = String(severity || 'info').toLowerCase();
  if (['critical', 'high', 'error', 'danger', '严重', 'fatal'].some((x) => s.includes(x))) {
    return 'severity-high';
  }
  if (['warning', 'medium', 'warn', '警告'].some((x) => s.includes(x))) {
    return 'severity-medium';
  }
  return 'severity-low';
}

export function formatRevisionSeverityLabel(severity) {
  const cls = normalizeRevisionSeverityClass(severity);
  if (cls === 'severity-high') return '严重';
  if (cls === 'severity-medium') return '警告';
  return '提示';
}

/**
 * 检测总指令是否有任何非空字段。
 * 必须覆盖前端 collectMasterRevisionInstructions() 返回的所有 key，
 * 否则用户只填了 qa/searchTerms/general 时按钮会错误地保持 disabled。
 */
export function hasAnyMasterRevisionText(master) {
  if (!master) return false;
  return ['general', 'title', 'bullets', 'description', 'aplus', 'qa', 'searchTerms']
    .some((k) => String(master[k] || '').trim());
}
